import React from "react";
import GolfSoloInputContainer from "../organisms/golfSoloInputContainer";
import { SubHeader } from '../molecules/subHeader';
import SubHeader2 from '../../resources/image/subHeader2.png';
import { GolfSoloHeaderContainer } from "../organisms/golfSoloHeaderContainer";
import GolfSoloReservationPopupContainer from "../organisms/golfSoloReservationPopupContainer";

class GolfSoloInputTemplate extends React.Component {

  render() {
    return (
      <div>
        <GolfSoloHeaderContainer
          Label categoryLabel1={"利用者入力"}
          categoryLabel2={"USER INPUT"}
          path="/reserve/golf/soloStartTime"
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
        />
        <SubHeader SubImage={SubHeader2} />
        <GolfSoloReservationPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
        />
        <GolfSoloInputContainer/>
      </div>
    );
  }
}
export default GolfSoloInputTemplate;